import {
	type AdminGoldenAsset,
	type GenerationTargetType,
	GOLDEN_ASSET_KIND_LABELS,
	type GoldenAssetKind,
	type GoldenAssetOwnerType,
} from "@storyline/shared";
import AssetSlotView from "@/src/series/components/asset-slot";
import { selectAssetSlot, slotKey } from "@/src/series/utils/asset-slots";

type AssetRowProps = {
	ownerType: GoldenAssetOwnerType;
	ownerId: string | null;
	targetType: GenerationTargetType;
	targetId: string;
	kinds: GoldenAssetKind[];
	assets: AdminGoldenAsset[];
	generatingKeys: Set<string>;
	onGenerate: (targetType: GenerationTargetType, targetId: string, kind: GoldenAssetKind) => Promise<void>;
	onApprove: (assetId: string) => Promise<void>;
	onLock: (assetId: string) => Promise<void>;
	onUnlock: (assetId: string) => Promise<void>;
};

const AssetRow: React.FC<AssetRowProps> = ({
	ownerType,
	ownerId,
	targetType,
	targetId,
	kinds,
	assets,
	generatingKeys,
	onGenerate,
	onApprove,
	onLock,
	onUnlock,
}) => (
	<div className="flex flex-wrap gap-4 overflow-x-auto">
		{kinds.map((kind) => (
			<AssetSlotView
				key={kind}
				label={GOLDEN_ASSET_KIND_LABELS[kind]}
				slot={selectAssetSlot(assets, ownerType, ownerId, kind)}
				isGenerating={generatingKeys.has(slotKey(targetId, kind))}
				onGenerate={() => onGenerate(targetType, targetId, kind)}
				onApprove={onApprove}
				onLock={onLock}
				onUnlock={onUnlock}
			/>
		))}
	</div>
);

export default AssetRow;
